module.exports = __webpack_public_path__ + "img/公司介绍@2x.ac1506ae.png";